/**
 * Reads the Phoenix CSRF token from the `<meta name="csrf-token">` tag
 * injected per-request by `MatrixStudio.Controllers.StaticHtmlHelper`.
 *
 * Returns the token string when the tag is present, or an empty string when
 * it isn't (SSR contexts, missing tag, etc.). Callers that need to skip a
 * request when no token is available should branch on the empty string
 * explicitly — this helper deliberately doesn't throw so it can be wrapped
 * in `useMemo`-style hooks without surprising the renderer.
 */
export function getCsrfToken(): string {
  if (typeof document === 'undefined') return '';
  return (
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
  );
}
